import { assignSelector } from './assign.selectors';
import { createSelector } from '@ngrx/store';
import * as fromAdvancedFilters from '../reducers/advanced-filters.reducer';

export const selectAdvancedFiltersState = createSelector(
  assignSelector,
  (state) => state[fromAdvancedFilters.featureKey],
);

export const selectAdvancedFilters = createSelector(selectAdvancedFiltersState, fromAdvancedFilters.getFilters);

export const selectCountReadyOrders = createSelector(
  selectAdvancedFiltersState,
  fromAdvancedFilters.getCountReadyOrders,
);

export const selectCountHoldOrders = createSelector(selectAdvancedFiltersState, fromAdvancedFilters.getCountHoldOrders);

export const selectCountScheduleOrders = createSelector(
  selectAdvancedFiltersState,
  fromAdvancedFilters.getCountScheduleOrders,
);
